import { createApp } from 'vue'
import App from '@/App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import { createHead } from '@vueuse/head'
import '@/assets/main.css'
import '@/assets/fonts.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(router)
app.use(vuetify)
app.mount('#app')
